import { render } from "./PlaceholderPage.vue?vue&type=template&id=8f82b9a2&scoped=true"
import script from "./PlaceholderPage.vue?vue&type=script&lang=js"
export * from "./PlaceholderPage.vue?vue&type=script&lang=js"

import "./PlaceholderPage.vue?vue&type=style&index=0&id=8f82b9a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f82b9a2"]])

export default __exports__